<template>
  <div id="welcome">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'welcome'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/situation/welcome/Welcome.vue